import { useEffect } from 'react';
/**
 * Injects the PX 3rd party script once
 * https://docs.perimeterx.com/pxconsole/docs/integrate-third-party-client
 * @param pxAppId
 */
export function useInjectPX3rdPartyScript(pxAppId) {
  useEffect(function () {
    var dataTest = 'px_3rd_party_script';
    if (document.querySelector("[data-test=\"".concat(dataTest, "\"]"))) {
      try {
        document.head.removeChild(document.querySelector("[data-test=\"".concat(dataTest, "\"]")));
      } catch (error) {
        /* istanbul ignore next */
        console.error('could not remove px script child', error);
      }
    }
    if (document.querySelector('[src="//client.perimeterx.net/PXzYvFOXaC/main.min.js"]')) {
      return; // in prod only adobe tag manager already injects this script so no need to insert twice
    }

    var script = document.createElement('script');
    script.async = true;
    script.src = "//client.px-cloud.net/".concat(pxAppId, "/main.min.js");
    script.setAttribute('data-test', dataTest);
    try {
      document.head.prepend(script);
    } catch (error) {
      /* istanbul ignore next */
      console.error('error injecting px 3rd script');
    }
  }, [pxAppId]);
}